var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.isLoading)?_c('loading',{staticClass:"mx-auto"},[_vm._v(" Загрузка данных подпрограммы ")]):[(_vm.isOms)?_c('InsuranceSubprogramCreatePageOMS',{attrs:{"initial-data":_vm.initialData}}):_c('InsuranceSubprogramCreatePageDMS',{attrs:{"initial-data":_vm.initialData}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }